import { staticNotifications } from './constants'
import { addAndFilterNotifications } from './helper'
import {
  Actions,
  type ActionTypes,
  type InitialState,
  type NotificationOptions,
  NotificationType,
} from './types'

const initialState: InitialState = {
  main: [],
  secondary: [],
  socket: [],
  ai: [],
}

export const notification = (
  state: InitialState = initialState,
  action: ActionTypes
) => {
  switch (action.type) {
    case Actions.NOTIFICATION: {
      const notify: NotificationOptions =
        staticNotifications[action.payload.type]

      notify.callback = action.payload.callback
      notify.closeCallback = action.payload.closeCallback
      notify.actionText = action.payload.actionText || notify.actionText

      const notificationStack =
        notify.toastContainerId === 'main'
          ? [notify]
          : addAndFilterNotifications(state[notify.toastContainerId], notify)

      return {
        ...state,
        [notify.toastContainerId]: notificationStack,
      }
    }
    case Actions.SOCKET_NOTIFICATION: {
      const notify: NotificationOptions =
        staticNotifications[action.payload.type]

      notify.callback = action.payload.callback
      notify.closeCallback = action.payload.closeCallback
      notify.actionText = notify.actionText
        ? notify.actionText
        : action.payload.actionText

      const socketNotification =
        action.payload.type === NotificationType.ONLINE ? [] : [notify]

      return { ...state, [notify.toastContainerId]: socketNotification }
    }
    case Actions.CUSTOM_NOTIFICATION: {
      const notify: NotificationOptions = action.payload

      const notificationStack =
        notify.toastContainerId === 'main'
          ? [notify]
          : addAndFilterNotifications(state[notify.toastContainerId], notify)

      return {
        ...state,
        [notify.toastContainerId]: notificationStack,
      }
    }
    case Actions.CLEAR_NOTIFICATION: {
      const key = action.payload.toastContainerId
        ? action.payload.toastContainerId
        : 'secondary'
      const index = action.payload.index ? action.payload.index : 0
      const clonedArr = [...state[key]]

      clonedArr.splice(index, 1)

      return { ...state, [key]: clonedArr }
    }
    case Actions.CLEAR_ALL_NOTIFICATION: {
      // The socket container holds what stands until a reconnect or a reload
      // (offline, saving refused): a passing toast does not take it away.
      return { ...state, main: [], secondary: [] }
    }
    default: {
      return state
    }
  }
}
